import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { IAppModel } from "@/model";

/**
 * 应用类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class AppService extends ServiceBase {
    /**
     * 添加应用
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async addApp(data: IAppModel): Promise<IHttpResponse> {
        let response = await this.apis.addApp({ data });
        return response;
    }

    /**
     * 删除应用
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteApp(id: number): Promise<IHttpResponse> {
        let response = await this.apis.deleteApp({ urlPath: { id } });
        return response;
    }

    /**
     * 修改应用
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async editApp(data: IAppModel): Promise<IHttpResponse> {
        let response = await this.apis.editApp({ data });
        return response;
    }

    /**
     * 获取应用分页数据
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getAppPage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getAppPage({ data });
        return response;
    }

    /**
     * 设置默认应用
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async setAppAsDefault(id: number): Promise<IHttpResponse> {
        let response = await this.apis.setAppAsDefault({ params: { id } });
        return response;
    }

    /**
     * 修改应用状态
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async changeAppStatus(data: any): Promise<IHttpResponse> {
        let response = await this.apis.changeAppStatus({ data });
        return response;
    }

    /**
     * 获取应用列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getAppList(): Promise<IHttpResponse> {
        let response = await this.apis.getAppList({  });
        return response;
    }
}